import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  apiGetEngagement,
  apiSaveEngagement,
  apiUpdateEngagement,
} from "../../../api/ApiEngagement";
import { useTranslation } from "react-i18next";
import ModalCropImage from "../../layout/ModalCropImage";
import { MdDelete } from "react-icons/md";

const initialState = {
  nom: "",
  cardPic: "",
};

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;
  const [state, setState] = useState(initialState);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [croppedImage, setCroppedImage] = useState("");
  const [image, setImage] = useState("");
  const [showModalCrop, setShowModalCrop] = useState(false);

  const recupData = async () => {
    const res = await apiGetEngagement(ReduxInstance._id, id);
    setState(res.data);
  };

  const submitData = async () => {
    const myForm = new FormData();
    Object.keys(state).forEach((key) => {
      if (Array.isArray(state[key])) {
        state[key].forEach((element) => {
          myForm.append(key + "[]", element);
        });
      } else {
        myForm.append(key, state[key]);
      }
    });
    if (image) {
      myForm.append("cardPic", croppedImage);
    }

    if (id) {
      await apiUpdateEngagement(id, myForm);
      setState(initialState);
      setCroppedImage("");
      handleRecupDatas();
    } else {
      await apiSaveEngagement(ReduxInstance._id, myForm);
      setState(initialState);
      setCroppedImage("");
      handleRecupDatas();
    }
    handleClose();
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  const emptyImage = () => {
    setImage("");
    setCroppedImage("");
    setState({ ...state, cardPic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  useEffect(() => {
    if (id) recupData();
    else setState(initialState);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {id
            ? t("admin.PageAdminEngagements.modalCreateEditTitre2")
            : t("admin.PageAdminEngagements.modalCreateEditTitre1")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            placeholder={t("commun.form.placeholder.placeholder1")}
            value={state.nom}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          {croppedImage ? (
            <div>
              <div className="mt-2">{t("commun.form.label.image")}</div>
              <Image src={URL.createObjectURL(croppedImage)} width={300} height={150} />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : state.cardPic ? (
            <div>
              <div className="mt-2">{t("commun.form.label.image")}</div>
              <Image
                width={300}
                src={process.env.REACT_APP_URL_EXPRESS + "images/engagement/" + state.cardPic}
              />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : (
            <div>
              <label className="mt-2">{t("commun.form.label.image")}</label>
              <Form.Control type="file" accept="image/*" onChange={onSelectedFile} />
            </div>
          )}
          <ModalCropImage
            show={showModalCrop}
            image={image}
            handleClose={handleCloseCrop}
            resetImage={emptyImage}
            setImageCropped={setCroppedImage}
            xRatio={300}
            yRatio={150}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
